export default __webpack_public_path__ + "static/media/gallerySub1.642978f9.png";